import { Language } from './Language.model';
import { Product } from './Product.model';
import { ReportTemplate } from './ReportTemplate.model';

export interface Application {
  product: Product;
  header: string;
  templates: ReportTemplate[];
  languages: Language[];
}

// ---- Teleophth ----
const appTeleophthSmall = {
  product: Product.TELEOPHTH,
  header: 'teleophth',
  templates: [ReportTemplate.TELEOPHTH],
  languages: [Language.ENGLISH],
};

// ---- Teleophth Standalone ----
const appTeleophthStandaloneSmall = {
  product: Product.TELEOPHTH_STANDALONE,
  header: 'teleophth-standalone',
  templates: [ReportTemplate.TELEOPHTH],
  languages: [Language.ENGLISH],
};

const ApplicationInstance = (product: Product): Application => {
  if (product === Product.TELEOPHTH) {
    return appTeleophthSmall;
  }

  if (product === Product.TELEOPHTH_STANDALONE) {
    return appTeleophthStandaloneSmall;
  }

  console.log(`Unknown app for ${product}, use teleophth small as default`);
  return appTeleophthSmall;
};

export { ApplicationInstance };
